import { render, staticRenderFns } from "./Explore.vue?vue&type=template&id=523b264f&scoped=true&"
import script from "./Explore.vue?vue&type=script&lang=js&"
export * from "./Explore.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "523b264f",
  null
  
)

export default component.exports